import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useLoaderData } from 'react-router-dom';
import { Result } from '../../types/Result';
import { professionColumns } from './columns';

export default function ProfessionDataGrid() {
  const data = useLoaderData() as Result<any>;
  return (
    <DataGrid
      autoHeight
      sx={{ width: "100%" }}
      rows={data.data}
      getRowId={(row => row.professionCode)}
      columns={professionColumns}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
      }}
      pageSizeOptions={[10, 20, 50]}
      disableColumnResize
      density="compact"
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: 'outlined',
                size: 'small',
              },
            },
          },
        },
      }}
    />
  );
}